import axios from 'axios';

// Create axios instance with configurable base URL
const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || 'https://code.stacknora.com',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// API service functions
export const javaApi = {
  /**
   * Execute Java code
   * @param {string} code - Java code to execute
   * @param {string} input - Input for the Java program
   * @returns {Promise} Response with execution results
   */
  executeCode: async (code, input) => {
    try {
      const response = await api.post('/execute/java', {
        code,
        input
      });
      return response.data;
    } catch (error) {
      console.error('API Error:', error);
      throw error;
    }
  }
};

export default api;
